import textStyles from '../TextMenu.module.css'
import exDelivery from '../../Img/Menu/Delivery/exRegion.png'
import exCDEK from '../../Img/Menu/Delivery/exCDEK.png'
import exPOST from '../../Img/Menu/Delivery/exPost.png'
import exSALOON from '../../Img/Menu/Delivery/exSaloon.png'
import exSELF from '../../Img/Menu/Delivery/exSelf.png'
import logoPost from '../../Img/Delivery/logoPost.png'
import logoCdek from '../../Img/Delivery/logoCdek.png'
import logoSelf from '../../Img/Delivery/logoSelf.png'
import logoEsim from '../../Img/Delivery/logoEsim.png'
import logoSaloon from '../../Img/Delivery/logoSaloon.png'
import {useDispatch} from "react-redux";
import {setMainMenuId} from "../../Reducer/GlobalReducer";
import {Helmet} from "react-helmet";
import React from "react";


export default function MenuDelivery(){
    return(
        <div className={textStyles.mainCont}>
            <Helmet>
                <title>sim-unlim : Доставка</title>
                <link rel="canonical" href="https://sim-unlim.com/delivery" />
                <meta name="description" content="Самовывоз СДЭК почта России Офис салон оператора" />
            </Helmet>
            <div className={textStyles.head}><p >Варианты доставки</p></div>
            <div className={textStyles.blStart}>
                <p className={textStyles.ident}>
                    Получение заказа доступно следующими способами
                </p>
                <ul>
                    <li>
                        Транспортная компания ( СДЭК, Почта России )
                    </li>
                    <li>
                        Офис оператора связи
                    </li>
                    <li>
                        Самовывоз
                    </li>
                </ul>

            </div>
            <div style={{margin:"20px 0 0 0"}}>
                <p className={textStyles.bold}>Транспортная компания</p>

            </div>

            <div className={textStyles.blStart}>
                <p className={textStyles.ident}>
                    Доставка товара осуществляется транспортными компаниями до пункта выдачи заказов (далее - ПВЗ). Выбор транспортной компании осуществляется Заказчиком при оформлении заказа из перечня представленных на сайте. Получателем товара является заказчик либо лицо им уполномоченное. Получение заказа осуществляется при предъявлении документа удостоверяющего личность.
                </p>

                <p className={textStyles.ident}>
                    Стоимость доставки не включена в стоимость товара и рассчитывается отдельно при оформлении заказа.
                </p>
                <p className={textStyles.ident}>
                    Доступность товара для конкретного региона осуществляется автоматически при формировании заказа. Доставка товара невозможна в регион, отличный от региона действия тарифа.
                </p>
                <p className={textStyles.ident}>
                    Выбор региона осуществляется в левом верхнем углу сайта.
                </p>

            </div>

            <div className={textStyles.imgCont}>
                <img className={textStyles.widthImg} src={exDelivery}></img>
                <div className={textStyles.imgTitle}>Рисунок 1. (Выбор региона)</div>
            </div>









            <p className={textStyles.ident}>
                Компания не несет ответственности за  неверно указанные данные, что ведет к невозможности получения товара.  Договор считается исполненным надлежащим образом, оплата не возвращается. Ориентировочный срок доставки рассчитывается автоматически при формировании заказа. Срок доставки может быть скорректирован транспортной компанией.

            </p>


                <p className={textStyles.bold}>
                    Варианты Выбора транспортной компании и ПВЗ
                </p>

            <div className={textStyles.imgCont}>
                <img className={textStyles.widthImg} src={exCDEK}></img>
                <div className={textStyles.imgTitle}>Рисунок 2. (Доставка СДЭК)</div>
            </div>





            <div style={{margin:"20px 0 0 0"}}>
                <p className={textStyles.bold}>Собственный салон оператора связи</p>

            </div>
            <div className={textStyles.blStart}>
                <p className={textStyles.ident}>
                    Выбор данного способа получения заказа доступен не для всех тарифов, представленных на сайте и возможен только при наличии в населенном пункте Заказчика офиса оператора связи с возможностью проведения процедуры «замена сим карты».
                </p>
                <p className={textStyles.ident}>
                    Заказчик самостоятельно осуществляет поиск салона связи с возможностью проведения процедуры «замена сим карты» в своем  населенном пункте.

                </p>
                <p className={textStyles.ident}>
                    В случае отсутствия офиса оператора связи в населенном пункте Заказчика следует выбрать другой способ получения заказа.
                </p>
                <p className={textStyles.ident}>
                    Заказчик получает заказ в собственном офисе оператора связи, после оформления заказа на сайте. Получение заказа осуществляется при предъявлении документа удостоверяющего личность, который указывался при оформлении заказа. Получение сим карты происходит через процедуру «замена сим карты», оператор связи может взимать плату за проведение данной операции.
                </p>
                <p className={textStyles.ident}>
                    В случае возникновения проблем при получении заказа Заказчику следует создать обращение в личном кабинете или  обратиться в службу поддержки  по телефону (звонок, WatsApp, Telegram), указанному на сайте.

                </p>

            </div>



            <div style={{margin:"20px 0 0 0"}}>
                <p className={textStyles.bold}>Самовывоз</p>

            </div>
            <div className={textStyles.blStart}>
                <p className={textStyles.ident}>
                    Выбор пункта самовывоза осуществляется Заказчиком при оформлении заказа из перечня представленных на сайте. Получателем товара является Заказчик либо лицо им уполномоченное. Получение заказа осуществляется при предъявлении документа удостоверяющего личность.
                </p>
                <p className={textStyles.ident}>
                    Требуется предварительная запись по телефону (звонок, WatsApp, Telegram), указанному на сайте.
                </p>
            </div>







        </div>
    )
}